var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"navbar-layout"},[_c('YynNavBar',{scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('NavBarSlotsRight')]},proxy:true}])}),_c('DefaultLayout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }